import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { border, display, maxHeight } from '@mui/system';
import { GridValueGetterParams } from '@mui/x-data-grid';
import React, { CSSProperties } from 'react';
import { container } from 'src/components/VemigoGrid/CustomDataTable/styles';

export const TabsContainerWrapper = styled(Box)(
  ({ theme }) => `
        .MuiTabs-indicator {
            background-color: #11192A;
            box-shadow: 0px -1px 2px rgba(0, 0, 0, 0.3);
            color: 'red';
            border: 10px;
            border-radius: 0;
        }
  `
);

export const TabsBoxSelector = styled(Box)(
  ({ theme }) => `
        .MuiTabs-indicator {
          // background-color: #FFFF;
          box-shadow: 0px -1px 2px rgba(0, 0, 0, 0.3);
          color: 'red';
          border: 10px;
          border-radius: 0;
        }
  `
);

export const color = {
  searchBar: 'white'
};

export const selectInputField = {
  input: {
    textAlign: 'right',
    padding: '0 9px 0 0',
    border: 'none',
    backgroundColor: 'red',
    borderRadius: '9px 9px 9px 9px',
    boxShadow: ' ',
    outline: 'none',
    width: '50px',
    height: '50px',
    minHeigth: '50px',
    minWidth: '50px',
    color: 'black',
    background: color.searchBar
  } as React.CSSProperties
};

export const searchBarComponent = {
  container: {
    display: 'flex',
    padding: '1%',
    alignItems: 'center',
    width: 'fit-content',
    margin: 'auto 0 auto auto'
  },
  searchBarContainer: {
    container: {
      display: 'flex',
      alignItems: 'center',
      padding: '3px',
      background: color.searchBar,
      borderRadius: '10px'
    },
    dropDown: {
      display: 'flex',
      alignItems: 'flex-start',
      maxHeight: '150px',
      padding: '3px',
      background: color.searchBar,
      borderRadius: '10px',
      flexDirection: 'column'
    },
    icon: {
      padding: '0 0 0 3px'
    },
    inputFeild: {
      padding: '8px',
      border: 'none',
      borderRadius: '0 9px 9px 0',
      outline: 'none',
      width: '36vw',
      minWidth: '100px',
      color: 'black',
      background: color.searchBar
    },
    renderBox: {
      margin: '0 0 0 30px',
      alignItem: 'centre',
      display: 'flex',
      fontSize: '16px'

      // background: 'black'
    }
  }
};

export const useStyles = {
  dialogTitle: {
    backgroundColor: '#FFFFFF',
    color: '#000000',
    borderBottom: 1,
    borderColor: 'divider'
  },
  bodyStyle: {
    borderBottom: 1,
    borderColor: 'divider',
    backgroundColor: '#F7F8FA'
  },
  boxSize: {
    width: '60vh',
    height: '60vh'
  },
  expandText: {
    padding: '9px 0px 0px 9px'
  },
  formControl: {
    marginBottom: '-9px',
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    boxShadow: '0px 0px 1px rgb(0, 0, 0, 0.9)',
    margin: '1px 0px 1px 0px'
  },
  readonlyFormControl: {
    marginBottom: '-9px',
    backgroundColor: '#FFFFFF',
    border: '0',
    margin: '1px 0px 1px 0px',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      border: '0'
    }
  },
  formLabel: {
    margin: '5px 0 1px 0',
    color: 'black'
  },
  titleLabel: {
    // margin: '3px 0 1px 0',
    color: 'black'
  },
  formButton: {
    backgroundColor: '#FFFFFF',
    color: '#000',
    borderRadius: '33px',
    width: '100px',
    boxShadow: '0px 0px 3px rgb(0, 0, 0, 0.9)'
  },
  formTitle: {
    margin: '1.5vh 0vh 0.5vh 0vh'
  },
  statusBox: {
    bottom: '6vh',
    width: '100%'
  },
  formStatus: {
    marginTop: '4px'
  },
  tabsBox: {
    background: 'transparent',
    width: 'fit-content',
    boxShadow: '-1px 0px 1px rgba(0, 0, 0, 0.2)'
  },
  activeTabStyle: {}
};

export const tabStyle = {
  backgroundColor: '#FFFFFF'
};

export const activeTabStyle = {
  backgroundColor: '#11192A',
  color: '#FFFFFF',
  borderRadius: '0',
  borderRight: '0'
};

export const TabsBox = {
  borderLeft: '1px solid #ccc',
  background: 'transperent',
  width: 'fit-content',
  height: 'fit-content',
  boxShadow: '3px 0px 6px rgba(0, 0, 0, 0.2)',
  flex: 0
};

export const statusStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '18px',
  width: '90px',
  height: '30px',
  fontSize: '13px'
};

export const renderStatusCell = (params: GridValueGetterParams) => {
  const status = params.value as string;

  const backgroundColor = status
    ? 'rgba(108, 226, 98, 0.36)'
    : 'rgba(255, 50, 50, 0.30)';
  const statusText = status ? 'Active' : 'Inactive';
  return (
    <div
      style={{
        backgroundColor,
        ...statusStyle
      }}
    >
      {statusText}
    </div>
  );
};

export const renderOnlyBackendCell = (params: GridValueGetterParams) => {
  const status = params.value as string;

  const backgroundColor = status
    ? 'rgba(108, 226, 98, 0.36)'
    : 'rgba(255, 50, 50, 0.30)';
  const statusText = status ? 'True' : 'False';
  return (
    <div
      style={{
        backgroundColor,
        ...statusStyle
      }}
    >
      {statusText}
    </div>
  );
};

export const renderStatusCellDT = (data) => {
  const status = data as string;

  const backgroundColor = status
    ? 'rgba(108, 226, 98, 0.36)'
    : 'rgba(255, 50, 50, 0.30)';
  const statusText = status ? 'Active' : 'Inactive';
  return (
    <div
      style={{
        backgroundColor,
        ...statusStyle
      }}
    >
      {statusText}
    </div>
  );
};

export const renderStatusCellY_N = (params: GridValueGetterParams) => {
  const status = params.value as string;
  const backgroundColor = status
    ? 'rgba(108, 226, 98, 0.36)'
    : 'rgba(255, 50, 50, 0.30)';
  const statusText = status ? 'Yes' : 'No';
  return (
    <div
      style={{
        backgroundColor,
        ...statusStyle
      }}
    >
      {statusText}
    </div>
  );
};

export const ReusableCellRenderer = ({ value }) => (
  <div
    style={{
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      paddingTop: '9px'
    }}
  >
    {value}
  </div>
);

export const statusCellForBooking = (data, color) => {
  const status = data as string;

  const backgroundColor =
    color === 1
      ? 'rgba(108, 226, 98, 0.36)'
      : color === 2
        ? 'rgba(255, 215, 0, 0.36)'
        : 'rgba(255, 196, 25, 0.36)';

  return (
    <div
      style={{
        backgroundColor,
        ...statusStyle
      }}
    >
      {status}
    </div>
  );
};

////////////////////////////// customer page styling ////////////////////////////////////////////

interface CustomerStyle {
  containerStyle: React.CSSProperties;
  backgContainer: React.CSSProperties;
  recentSearchStyle: React.CSSProperties;
  fieldContainerStyle: React.CSSProperties;
  fieldStyle: React.CSSProperties;
  divider: React.CSSProperties;
  squareStyle: React.CSSProperties;
  contentStyle: React.CSSProperties;
  subContentStyle: React.CSSProperties;
  details: React.CSSProperties;
  details2: React.CSSProperties;
  numberIcon: React.CSSProperties;
  iconstyle: React.CSSProperties;
}

export const customerStyle: CustomerStyle = {
  containerStyle: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '10px',
    justifyContent: 'center',
    height: 'fit-content',
    marginTop: '50px'
  },
  details: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 0 2% 20%'
  },
  details2: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '10%'
  },
  iconstyle: {
    marginRight: '6px',
    fontSize: '45px',
    color: '#BDBDBD'
  },
  numberIcon: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '15%'
  },
  backgContainer: {
    marginTop: '-8vh',
    backgroundColor: '#F7F9FB',
    padding: '15px',
    marginLeft: '15px',
    marginRight: '5vh',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'
  },
  recentSearchStyle: {
    fontSize: '20px',
    fontWeight: 'bold',
    marginBottom: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
    // padding: '1%',
  },
  fieldContainerStyle: {
    marginLeft: '270px',
    marginRight: '25px',
    marginTop: '10px',
    background: '#FFFFFF',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    padding: '10px'
  },
  fieldStyle: {
    display: 'flex',
    gap: '20px'
  },
  divider: {
    marginBottom: '5px'
  },
  squareStyle: {
    width: '185px',
    height: '150px',
    backgroundColor: 'white',
    position: 'relative',
    transition: 'box-shadow 0.3s ease',
    margin: '3%'
  },
  contentStyle: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: 'black',
    fontSize: '18px',
    fontWeight: 'bold',
    paddingTop: '10px',
    marginLeft: '-30px'
  },
  subContentStyle: {
    width: '80%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
    marginLeft: '50px',
    alignItems: 'center',
    color: '#9747FF',
    fontSize: '12px',
    backgroundColor: '#9747FF0A',
    borderWidth: '1px',
    borderStyle: 'dashed',
    borderRadius: '5px',
    whiteSpace: 'nowrap',
    padding: '4px 42px 4px 42px'
  }
};

export const CommunicatinPageStyle = {
  chatText: {
    fontSize: '15px'
  },
  chatBubble: {
    borderRadius: '10px',
    padding: '15px',
    margin: '10px',
    backgroundColor: ' #387ADF',
    color: 'white',
    marginLeft: '40%',
    width: 'auto',
    height: 'auto'
  },
  customerChat: {
    borderRadius: '10px',
    padding: '15px',
    margin: '10px',
    backgroundColor: ' #C7C8CC',
    marginRight: '40%',
    marginBottom: '20px'
  },
  followUp: {
    borderRadius: '5px',
    padding: '15px',
    margin: '10px',
    backgroundColor: '#C7C8CC'
  },
  previousBtn: {
    color: '#4F5AED',
    background: '#F0F1FA',
    marginLeft: '80%',
    marginRight: 'auto',
    width: 'auto',
    padding: '5px',
    marginTop: '2%',
    cursor: 'pointer',
    borderRadius: '10px'
  },
  date: {
    margin: '5% 0 5% 32%'
  }
};

export const settingsServicePage = {
  subBox: (expanded?: boolean, data?: []) => ({
    container: {
      marginBottom: '10px',
      borderRadius: '10px',
      width: '100%',
      minHeight: data.length > 0 ? '10vh' : '5vh',
      maxHeight: expanded || data.length > 0 ? '30vh' : '10vh',
      padding: '10px 10px 10px 18px',
      boxShadow: '0 0 1px rgba(0, 0, 0, 0.9)',
      overflowY: 'hidden',
      transition: 'max-height 0.3s ease'
    } as CSSProperties,
    addContainer: {
      width: '100%',
      minHeight: data.length === 0 ? '0' : '5vh',
      maxHeight: expanded || data.length > 1 ? '21vh' : '10vh',
      overflowY: expanded || data.length > 1 ? 'scroll' : 'hidden',
      transition: 'max-height 0.3s ease'
    } as CSSProperties
  })
};

export const customerPageStyling = {
  container: {
    width: 'fit-contant',
    position: 'relative'
  } as CSSProperties,
  addBooking: (expanded?: boolean, index?: number) => ({
    resetBtn: {
      position: 'absolute',
      bottom: '-27px',
      left: '0px'
    } as CSSProperties,
    backBtn: {
      position: 'absolute',
      bottom: '-27px',
      right: '90px'
    } as CSSProperties,
    bookBtn: {
      position: 'absolute',
      bottom: '-27px',
      right: '0px'
    } as CSSProperties,
    addBookBtn: {
      margin: '20px 0'
    } as CSSProperties,
    cartContainer: {
      marginTop: '30px',
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      borderRadius: '10px',
      flexDirection: 'row',
      justifyContent: 'space-between'
    } as CSSProperties,
    cardContainer: {
      position: 'relative',
      width: '100%',
      height: expanded ? '60px' : '',
      margin: '10px 0 10px 0',
      padding: '3px 3px 60px 3px',
      borderRadius: '10px',
      boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.3)',
      transition: 'height 0.5s ease'
    } as React.CSSProperties,
    card:
      index !== undefined &&
      ({
        position: 'relative',
        width: '100%',
        padding: '30px',
        height: expanded ? undefined : '100%',
        overflow: 'hidden',
        transition: 'height 0.6s ease'
      } as React.CSSProperties),
    cardBtn: {
      cardTotal:
        index !== undefined &&
        ({
          height: '40px',
          minMidth: '90px',
          padding: '6px',
          position: 'absolute',
          bottom: '10px',
          left: !expanded && '30px',
          right: expanded && '100px',
          transition: 'transform 0.3s ease-in-out'
        } as React.CSSProperties),
      openBtn:
        index !== undefined &&
        ({
          position: 'absolute',
          bottom: '10px',
          right: '10px',
          transform: `rotate(${expanded ? '0deg' : '180deg'})`,
          transition: 'transform 0.3s ease-in-out'
        } as React.CSSProperties),
      cancelBtn: {
        position: 'absolute',
        bottom: '10px',
        right: '40px',
        transform: `rotate(${expanded ? '0deg' : '180deg'})`,
        transition: 'transform 0.3s ease-in-out'
      } as React.CSSProperties
    }
  }),
  selects: {
    header_btn: {
      width: '100%',
      display: 'flex',
      marginBottom: '10px',
      justifyContent: 'space-between',
      alignItems: 'center'
    } as React.CSSProperties,
    car: {
      container: {
        width: '100%',
        minHeight: '30px',
        padding: '3px',
        marginBottom: '30px',
        borderRadius: '10px',
        boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.3)'
      } as React.CSSProperties,
      holders: {
        width: '100%',
        padding: '10px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer'
      } as React.CSSProperties,
      elseHolders: {
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      } as React.CSSProperties,
      spanStyle: {
        margin: '9px',
        overflow: 'hidden',
        lineHeight: '2',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
      } as React.CSSProperties
    }
  }
};

export const TabesPage = {
  flex: 1,
  margin: '0 0 0 2vw',
  minWidth: '20vw'
};

export const bookingsServices = {
  actServicesStyle: {
    tableCointainer: {
      width: '100%',
      minHeight: '10vh',
      maxHeight: '30vh',
      borderRadius: '6px',
      margin: '2vh 0',
      padding: '1rem',
      overflowY: 'auto',
      boxShadow: '0 0 3px rgba(0, 0, 0, 0.3)'
    } as React.CSSProperties,
    table: { width: '100%', borderCollapse: 'collapse' } as React.CSSProperties,
    th: {
      textAlign: 'center',
      padding: '8px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    } as React.CSSProperties,
    tb: {
      padding: '6px',
      textAlign: 'center',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    } as React.CSSProperties,
    addTabCointainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      width: '100%',
      minHeight: '10vh',
      borderRadius: '6px',
      margin: '2vh 0',
      padding: '1rem',
      boxShadow: '0 0 3px rgba(0, 0, 0, 0.3)',
      marginLeft: '20px'
    } as React.CSSProperties,
    addTabtd: {
      padding: '8px',
      textAlign: 'left',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    } as React.CSSProperties,
    notesCointainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      width: '100%',
      minHeight: '20vh',
      maxHeight: '50vh',
      borderRadius: '6px',
      margin: '2vh 0',
      padding: '1rem',
      boxShadow: '0 0 3px rgba(0, 0, 0, 0.3)'
    } as React.CSSProperties,
    selectContainer: {
      marginTop: '5px',
      display: 'flex',
      justifyContent: 'center'
    } as React.CSSProperties,
    selectDropdown: {
      width: '180px',
      borderRadius: '2px',
      border: '1px solid #ccc'
    } as React.CSSProperties,
    iconButton: {
      marginLeft: '5px',
      borderRadius: '10%',
      transition: 'background-color 0.3s',
      ':hover': {
        backgroundColor: '#e0e0e0'
      }
    } as React.CSSProperties,
    addSubscriptionTab: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%'
    } as React.CSSProperties,
    editAddressIcon: {
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '55px'
    } as React.CSSProperties
  }
};
